//管家列表
const getButlerListUrl = `/gateway/hc-neighbour/butler/getButlerInfoByHouseId`;

//获取管家评价
const getButlerCommentListURL = `/gateway/hc-neighbour/butler/getButlerEvaluateList`;
//管家评价
const commentListURL = `/gateway/hc-neighbour/butler/addButlerEvaluateRecord`;
export { getButlerListUrl, getButlerCommentListURL, commentListURL };
